import type { Feedback } from '@/pages/dsst-spick/dsstConfig';

interface NumberPadProps {
  onSelect: (n: number) => void;
  selectedNumber: number | null;
  feedback: Feedback;
  disabled: boolean;
  order?: number[];
}

// 스픽 스타일 숫자 패드
// - Spatial Span 타일과 동일한 입체 스타일(하단 립 + 그라데이션)을 그대로 사용한다.
// - 기본: 흰색 타일(중립 그레이 립) / 정답: 쨍한 블루 타일 / 오답: 레드 타일
export default function NumberPad({
  onSelect,
  selectedNumber,
  feedback,
  disabled,
  order,
}: NumberPadProps) {
  const numbers = order ?? [1, 2, 3, 4, 5, 6];
  return (
    <div className="w-full grid grid-cols-6 gap-2">
      {numbers.map((n) => {
        const isSelected = selectedNumber === n;
        const stateClass = isSelected
          ? feedback === 'correct'
            ? 'sh-tile-lit text-white scale-105'
            : 'sh-tile-wrong text-white scale-105'
          : 'sh-tile-default text-foreground-900';
        return (
          <button
            key={n}
            onClick={() => onSelect(n)}
            disabled={disabled}
            className={`sh-tile aspect-square flex items-center justify-center
              text-xl font-bold select-none transition-all duration-150 whitespace-nowrap
              cursor-pointer active:scale-95 ${stateClass}`}
            aria-label={`숫자 ${n}`}
          >
            {n}
          </button>
        );
      })}
    </div>
  );
}